import Cookies from "js-cookie";
// import { useAuth0 } from "@auth0/auth0-react";
// import { Auth0Client } from "@auth0/auth0-spa-js";

const COOKIE_TOKEN = "token";

const requests = {
	async get(url, opts = {}) {
		try {
			const headers = await getRequestHeaders(opts);

			const target = opts.isExternal ? process.env.EXTERNAL_API_URL : process.env.API_URL;

			let apiResp = await fetch(`${target}${url}`, { headers });
			return responseJson(apiResp);
		} catch (err) {
			return;
		}
	},

	async delete(url, opts = {}) {
		try {
			const headers = await getRequestHeaders(opts);
			const target = opts.isExternal ? process.env.EXTERNAL_API_URL : process.env.API_URL;

			let apiResp = await fetch(`${target}${url}`, { headers, method: "DELETE" });
			return responseJson(apiResp);
		} catch (err) {
			return;
		}
	},

	put: async (url, body, opts = {}) => {
		try {
			const target = opts.isExternal ? process.env.EXTERNAL_API_URL : process.env.API_URL;

			const headers = await getRequestHeaders(opts);

			const response = await fetch(
				new Request(`${target}${url}`, {
					body: JSON.stringify(body),
					method: "PUT",
					headers,
				})
			);

			return await responseJson(response);
		} catch (err) {
			throw err;
		}
	},

	post: async (url, body, opts = {}) => {
		try {
			const target = opts.isExternal ? process.env.EXTERNAL_API_URL : process.env.API_URL;
			const headers = await getRequestHeaders(opts);

			const response = await fetch(
				new Request(`${target}${url}`, {
					body: JSON.stringify(body),
					method: "POST",
					headers,
				})
			);

			return await responseJson(response);
		} catch (err) {
			throw err;
		}
	},
};

const responseJson = async (res) => {
	if (res.ok) {
		return res.text().then((text) => (text.length ? JSON.parse(text) : null));
	} else {
		return Promise.reject(res);
	}
};

const getRequestHeaders = async (opts) => {
	const headers = {
		"Content-Type": "application/json",
		Accept: "application/json",
		...(opts.isExternal && { mode: "no-cors" }),
	};

	// let token;

	// try {
	// 	token = await auth0.getTokenSilently();
	// } catch (err) {
	// 	console.error(err);
	// }
	// if (!!token) {
	if (!opts.token) {
		throw "No Token";
	}
	headers["Authorization"] = `bearer ${opts.token}`;
	// }

	return headers;
};

export default requests;
